import { mergeStyles } from '@cian/utils';
import classnames from 'classnames';
import * as React from 'react';
import { useDeviceCondition } from '../../../../hooks';
import * as styles from './Row.css';
import { ICheckoutRowProps } from './types';

export const Row = (props: ICheckoutRowProps) => {
  const rootStyle = useDeviceCondition(styles['desktop'], styles['mobile']);

  const { isTotal, isDiscount, name, note, value } = props;

  return (
    <div {...mergeStyles(rootStyle, styles['row'], isTotal && styles['total'])}>
      <div className={styles['name']}>{name}</div>
      <div className={styles['right-block']}>
        <div className={classnames(styles['value'], isDiscount && styles['discount'])}>{value}</div>
        {!!note && <div className={styles['note']}>{note}</div>}
      </div>
    </div>
  );
};
